import * as dict from "../dictionary"
import { checkProductType } from "../utils/checkProductType"
import { Chip } from "@mui/material"
import { showUnit } from "../utils/showUnit"
export const ChipRoomInfo = ({ houseInfo, houseInfoParse, icon, lang, sx, version }) => {

    const getProjectName = () => {
        if (lang === "en") {
            return houseInfo?.project_name_en || houseInfoParse?.project_name_en
        }
        return houseInfo?.project_name || houseInfoParse?.project_name
    }

    const getRoomNo = () => {
        //if(checkProductType() === "rental"){
        return houseInfo?.unit_number || houseInfoParse?.unit_number
        //}
        //return houseInfo?.house_number || houseInfoParse?.house_number
    }

    const getRoomNoTitle = () => {
        if (checkProductType() === "rental") {
            return dict.PropertyNo_TXT[lang]
        }
        return dict.Room_TXT[lang]
    }

    return <>
        <Chip sx={{
            ...sx, 
            maxWidth: "70dvw",
            width: "100%",
            height: 'auto',
            minWidth: "100%",
            "& .MuiChip-label": {
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            // For smaller screens
            "@media (max-width: 768px)": {
                "& .MuiChip-label": {
                    whiteSpace: "normal",
                    lineHeight: 1.4,
                }
            }
        }} 
        label={
            <>
                {
                    version === "fastcare" ? `${dict.Unit_Code_TXT[lang]} : ${showUnit(houseInfo?.unit_code, houseInfo?.unit_number)}` : `${dict.Project_TXT[lang]} : ${getProjectName() || '-'} | ${getRoomNoTitle()} : ${getRoomNo() || '-'}`
                }
            </>
        } color="primary" icon={icon} />
    </>
}